var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/es6.number.parse-float.js
// module id = FL8W
// module chunks = 0 3